<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container pt-4">
    <ngb-alert [type]="'info'" [dismissible]="false">
      If you are an implanter (eg Vet, Breeder, Rescue), please
      <a
        class="fw-bold"
        [href]="adminLoginUrl"
        target="_blank"
        rel="nofollow"
        >click here</a
      >
      to log into the admin site.
    </ngb-alert>

    <ngb-alert
      *ngIf="alert"
      [type]="alert.type"
      (closed)="closeAlert()"
      class="sticky-top"
      [class.bold]="alert.bold"
      style="top: 10px"
      ><span [innerHTML]="alert.message"></span
    ></ngb-alert>

    <div class="row mb-3">
      <div class="col-12">
      <h1 *ngIf="authWithChipNumber && hasChipNumberStatus === 0" class="text-center" [ngClass]="{'page-title': useRebrandedLayout }">Let's get started</h1>
      </div>
    </div>
    <div [ngClass]="{'d-flex justify-content-center': useRebrandedLayout}">
        <div [ngClass]="{'form-card h-100 p-4 w-50': useRebrandedLayout}">
            <div class="row mb-3" [ngClass]="{'d-flex justify-content-center': useRebrandedLayout}" *ngIf="hasChipNumberStatus === 0">
              <div class="col-12 col-lg-4 mx-auto text-center position-relative" [ngClass]="{'col-lg-10': useRebrandedLayout}">
                <p>
                  You need your pet's microchip number to register with us.
                </p>
                <p>
                  This is a 15 digit number, which you will receive from your vet, implanter or breeder and will be attached to your microchip flyer or paperwork.
                  <fa-icon
                  [icon]="['fas', 'circle-info']"
                  class="ms-1"
                  (mouseenter)="onIconHover(true)"
                  (mouseleave)="onIconHover(false)"
                >
                </fa-icon>
                </p>
                <div class="popover-content" *ngIf="isHovered">
                  <img src="/assets/images/identibase/chipnumberexample.png" class="popover-content-img" alt="microchipping">
                </div>
              </div>
            </div>
            <div class="row mb-3" [ngClass]="{'d-flex justify-content-center': useRebrandedLayout}" *ngIf="!authWithChipNumber && hasEmailOrPhoneNumberStatus === 0">
              <div class="col-12 col-lg-4 mx-auto text-center" [ngClass]="{'col-lg-10': useRebrandedLayout}">
                <p>
                  We need to check if you have an account with us already.
                </p>
              </div>
            </div>
            <!-- Chip number -->
            <div *ngIf="authWithChipNumber" class="row mb-2" [ngClass]="{'d-flex justify-content-center': useRebrandedLayout}">
              <div class="col-md-4 mb-3" [ngClass]="{'col-md-8': useRebrandedLayout}">
                <form #loginForm="ngForm" (ngSubmit)="login()" novalidate>
                  <div class="mb-1">
                    <div *ngIf="hasChipNumberStatus === 0" class="text-center">
                      <label class="form-label mb-0" for="email">Enter your pet's chip number:</label>
                    </div>
                    <div *ngIf="hasChipNumberStatus !== 0">
                      <label class="form-label mb-0" for="email">Chip number</label>
                    </div>
                    <div>
                      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                        <input
                          [class.is-invalid]="chipNumber.touched && !chipNumber.valid && notValidChipNumber"
                          id="chipNumber"
                          name="chipNumber"
                          [ngClass]="{
                            'input-success': hasChipNumberStatus === 1,
                            'input-warning': hasChipNumberStatus === 2
                          }"
                          (input)="onInputChange($any($event).target.value)"
                          [(ngModel)]="model.identifier"
                          [placeholder]="'Chip number'"
                          (ngModelChange)="closeAlert()"
                          autof
                          matInput
                          #chipNumber="ngModel"
                          required
                          maxlength="15"
                          minlength="15"
                          pattern="[0-9]*"
                        />
                        <!--This next div is needed to make the input high enough-->
                        <div class="dummy-div" matSuffix></div>
                        <mat-error *ngIf="(chipNumber.touched || chipNumber.dirty) && (chipNumber.errors?.pattern || (chipNumber.value && chipNumber.value.length !== 15))">
                          Only numeric characters with a length of 15 are allowed.
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div>
                    <div *ngIf="hasChipNumberStatus === 1" class="text-center partial-email__box">
                      <p class="mt-3" style="margin-bottom: 0 ">Pet already registered to an account: </p>
                      <p><b>{{partialEmail}}</b></p>
                    </div>
                  </div>
                  <div>
                    <div class="text-center">
                      <p *ngIf="hasChipNumberStatus === 1">
                        If this is your acount, please enter your password to log in:
                      </p>
                      <p *ngIf="hasChipNumberStatus === 2">
                        This chip is not yet registered to an identi account, click below to move to the next step.
                      </p>
                    </div>
                  </div>
                  <div *ngIf="hasChipNumberStatus === 1" class="mb-1">
                    <div>
                      <label class="form-label mb-0" for="password"> Password </label>
                    </div>
                    <div>
                      <mat-form-field appearance="outline" class="w-100">
                        <input
                          matInput
                          #password="ngModel"
                          [type]="hidePassword ? 'password' : 'text'"
                          id="password"
                          (ngModelChange)="closeAlert()"
                          name="password"
                          [(ngModel)]="model.password"
                          placeholder="Password"
                          required
                        />
                        <button
                          type="button"
                          mat-icon-button
                          matSuffix
                          (click)="hidePassword = !hidePassword"
                          [attr.aria-label]="'Hide password'"
                          [attr.aria-pressed]="hidePassword"
                        >
                          <mat-icon>{{
                            hidePassword ? "visibility_off" : "visibility"
                          }}</mat-icon>
                        </button>
                      </mat-form-field>
                    </div>
                  </div>
                  <button
                    type="button"
                    class="btn btn-lg btn-secondary text-white position-relative w-100 mt-1"
                    *ngIf="hasChipNumberStatus === 2"
                    (click)="onAuthWithChipNumberChanged(2)"
                    [disabled]="notValidChipNumber || this.chipNumberInputData.length === 0"
                  >
                    <fa-icon
                      *ngIf="loading"
                      [icon]="['fas', 'spinner']"
                      [animation]="'spin'"
                      class="me-3"
                    ></fa-icon>
                    <img
                    class="button-with-pawn"
                    src="/assets/images/identibase/whitepawlarge.png"
                    />
                    Continue
                  </button>

                  <button
                    type="button"
                    class="btn btn-lg btn-secondary text-white position-relative w-100 mt-1"
                    *ngIf="hasChipNumberStatus === 0"
                    (click)="checkChipDbClick()"
                    [disabled]="notValidChipNumber || this.chipNumberInputData.length === 0"
                  >
                    <fa-icon
                      *ngIf="loading"
                      [icon]="['fas', 'spinner']"
                      [animation]="'spin'"
                      class="me-3"
                    ></fa-icon>
                    <img
                    class="button-with-pawn"
                    src="/assets/images/identibase/whitepawlarge.png"
                    />
                    Continue
                  </button>
                  <div class="w-100 m-0 mt-3">
                    <div *ngIf="hasChipNumberStatus === 0">
                      <div class="d-flex justify-content-center">
                        Already have an account with us?
                      </div>
                      <button
                        type="button"
                        class="btn btn-primary btn-lg w-100 mt-1"
                        *ngIf="hasChipNumberStatus === 0"
                        (click)="redirectToLogIn()"
                      >
                        <fa-icon
                          *ngIf="loading"
                          [icon]="['fas', 'spinner']"
                          [animation]="'spin'"
                          class="me-3"
                        ></fa-icon>
                        Log in
                      </button>
                    </div>
                  </div>

                  <button
                    type="submit"
                    class="btn btn-brand-orange btn-lg bottom-buttons btn-secondary text-white position-relative w-100 mt-3"
                    *ngIf="hasChipNumberStatus === 1"
                  >
                    <fa-icon
                      *ngIf="loading"
                      [icon]="['fas', 'spinner']"
                      [animation]="'spin'"
                      class="me-3"
                    ></fa-icon>
                    <img
                    class="button-with-pawn"
                    src="/assets/images/identibase/whitepawlarge.png"
                    />
                    Log in
                  </button>

                  <button
                    type="button"
                    class="btn btn-primary btn-lg bottom-buttons w-100 mt-3"
                    *ngIf="hasChipNumberStatus === 1"
                    (click)="redirectToRecoverAccount()"
                  >
                    <fa-icon
                      *ngIf="loading"
                      [icon]="['fas', 'spinner']"
                      [animation]="'spin'"
                      class="me-3"
                    ></fa-icon>
                    Password reset
                  </button>
                  <div>
                    <div class="text-center mt-4">
                      <p *ngIf="hasChipNumberStatus === 1">
                        If you're the new keeper of this pet, please click below to continue with a transfer of keepership request
                      </p>
                    </div>
                  </div>

                  <button
                    type="button"
                    class="btn btn-success text-white btn-lg w-100 mt-2"
                    *ngIf="hasChipNumberStatus === 1"
                    (click)="redirectToTransferOfKeepership()"
                  >
                    <fa-icon
                      *ngIf="loading"
                      [icon]="['fas', 'spinner']"
                      [animation]="'spin'"
                      class="me-3"
                    ></fa-icon>
                    Transfer of keepership
                  </button>
                </form>
              </div>
            </div>
            <!-- Email address or phone number -->
            <div *ngIf="!authWithChipNumber" class="row mb-2" [ngClass]="{'d-flex justify-content-center': useRebrandedLayout}">
              <div class="col-md-4 mb-3" [ngClass]="{'col-md-8': useRebrandedLayout}">
                <form #emailCheckForm="ngForm">
                  <div class="mb-1">
                    <div class="text-center" [ngClass]="{'d-flex justify-content-center': useRebrandedLayout}">
                      <label class="form-label mb-0" for="email">Enter your email address or mobile number:</label>
                    </div>
                    <div [ngClass]="{'d-flex justify-content-center': useRebrandedLayout}">
                      <mat-form-field appearance="outline" class="w-100">
                        <input
                          [class.is-invalid]="emailOrPhone.touched && !emailOrPhone.valid"
                          id="emailOrPhone"
                          name="emailOrPhone"
                          [ngClass]="{
                            'input-success': hasEmailOrPhoneNumberStatus === 1,
                            'input-warning': hasEmailOrPhoneNumberStatus === 2
                          }"
                          (input)="onInputChangeForEmailOrPhone($any($event).target.value)"
                          [(ngModel)]="emailAndPhoneNumberInputData"
                          [placeholder]="'Email address or phone number'"
                          matInput
                          #emailOrPhone="ngModel"
                          required
                          pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$|^\+?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,11}$"
                        />
                        <!--This next div is needed to make the input high enough-->
                        <div class="dummy-div" matSuffix></div>
                        <mat-error *ngIf="emailOrPhone.touched && emailOrPhone.errors?.pattern">
                          Please enter a valid email address or phone number.
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div>
                    <div class="text-center">
                      <p *ngIf="hasEmailOrPhoneNumberStatus === 1" class="mb-0">
                        This email address is already registered in our database with an account. Please enter your password to log in.
                      </p>
                      <p *ngIf="hasEmailOrPhoneNumberStatus === 2" class="mb-0">
                        This email address is not yet registered with an account. Please click below to register an account with us
                      </p>
                    </div>
                  </div>
                  <div *ngIf="hasEmailOrPhoneNumberStatus === 1" class="mb-1">
                    <div>
                      <label class="form-label mb-0" for="password"> Password </label>
                    </div>
                    <div>
                      <mat-form-field appearance="outline" class="w-100">
                        <input
                          matInput
                          #password="ngModel"
                          [type]="hidePassword ? 'password' : 'text'"
                          id="password"
                          (ngModelChange)="closeAlert()"
                          name="password"
                          [(ngModel)]="model.password"
                          placeholder="Password"
                          required
                        />
                        <button
                          type="button"
                          mat-icon-button
                          matSuffix
                          (click)="hidePassword = !hidePassword"
                          [attr.aria-label]="'Hide password'"
                          [attr.aria-pressed]="hidePassword"
                        >
                          <mat-icon>{{
                            hidePassword ? "visibility_off" : "visibility"
                          }}</mat-icon>
                        </button>
                      </mat-form-field>
                    </div>
                  </div>
                  <button
                    type="submit"
                    class="btn btn-lg btn-secondary text-white position-relative w-100 mt-1"
                    *ngIf="hasEmailOrPhoneNumberStatus === 0"
                    (click)="checkEmailDbClick()"
                    [disabled]="!this.validEmail"
                  >
                    <fa-icon
                      *ngIf="loading"
                      [icon]="['fas', 'spinner']"
                      [animation]="'spin'"
                      class="me-3"
                    ></fa-icon>
                    <img
                    class="button-with-pawn"
                    src="/assets/images/identibase/whitepawlarge.png"
                    />
                    Continue
                  </button>
                  <button
                    type="button"
                    class="btn btn-lg bottom-buttons btn-secondary text-white position-relative w-100 mt-3"
                    *ngIf="hasEmailOrPhoneNumberStatus === 1"
                    (click)="login()"
                  >
                    <fa-icon
                      *ngIf="loading"
                      [icon]="['fas', 'spinner']"
                      [animation]="'spin'"
                      class="me-3"
                    ></fa-icon>
                    <img
                    class="button-with-pawn"
                    src="/assets/images/identibase/whitepawlarge.png"
                    />
                    Log in
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary btn-lg bottom-buttons w-100 mt-3"
                    *ngIf="hasEmailOrPhoneNumberStatus === 1"
                    (click)="redirectToRecoverAccount()"
                  >
                    <fa-icon
                      *ngIf="loading"
                      [icon]="['fas', 'spinner']"
                      [animation]="'spin'"
                      class="me-3"
                    ></fa-icon>
                    Password reset
                  </button>
                  <button
                    type="button"
                    class="btn btn-lg bottom-buttons btn-secondary text-white position-relative w-100 mt-3"
                    *ngIf="hasEmailOrPhoneNumberStatus === 2"
                    (click)="redirectToRegister()"
                  >
                    <fa-icon
                      *ngIf="loading"
                      [icon]="['fas', 'spinner']"
                      [animation]="'spin'"
                      class="me-3"
                    ></fa-icon>
                    <img
                    class="button-with-pawn"
                    src="/assets/images/identibase/whitepawlarge.png"
                    />
                    Continue
                  </button>
                </form>
              </div>
            </div>
        </div>
    </div>
    <div class="row mt-3 pb-5">
      <div
        class="col-md-4 col-sm-12 d-md-flex justify-content-center align-items-center offset-sm-0 offset-md-4 offset-lg-4"
      >
        <div class="w-100">
        </div>
      </div>
    </div>
  </div>
</div>
